import type {
    FetchConfigurationSpecificationsBodyType,
    PriceCalculationServiceEndpoint,
} from "../../../../common-deprecated/types/SpecTypes";
import type { BuildAndBuyStateType } from "../redux/store";
import { NavStep } from "../../shared-logic/utils/Navigation";
import { COMPONENT_PDF } from "../../../../shared-logic/server/components";
import { getExternalConfigOptionsAccessoryIdsDeprecated } from "../../../shared-logic/utils/typedUtils";
import { getPriceCalculationServiceEndpointType } from "../../../../common-deprecated/utils/specs";

export const getConfigSpecsBody = (
    state: BuildAndBuyStateType,
    returnSpecificationsMapping: boolean,
    overridePriceCalculationService?: PriceCalculationServiceEndpoint,
): FetchConfigurationSpecificationsBodyType => {
    const { car, basket, items, externalPrice, navigation, commonSettings, utils, bnbSettings } = state;

    const isPdf = commonSettings.component === COMPONENT_PDF;

    // Get the ids (used for the texus call GetTechnicalSpecificationMappings
    const ids = getExternalConfigOptionsAccessoryIdsDeprecated(basket, items, false, true);
    // Get the short ids (used for the wltp CAR-DB API specifications call)
    const shortIds = getExternalConfigOptionsAccessoryIdsDeprecated(basket, items, true, true);
    const options = ids.options.map((id, index) => ({ id, shortId: shortIds.options[index] }));
    const accessories = ids.accessories.map((id, index) => ({ id, shortId: shortIds.accessories[index] }));
    const packs = basket.packs.filter((item) => !item.standard).map((item) => ({ id: item.id, shortId: item.shortId }));
    const serviceProducts = basket.serviceProducts.map((serviceProduct) => ({
        id: serviceProduct.id,
        shortId: serviceProduct.shortId,
    }));
    let taxLocationId;

    if (
        (externalPrice.enabled && externalPrice.ready && !externalPrice.error && navigation.step === NavStep.Summary) ||
        isPdf
    ) {
        taxLocationId = externalPrice.taxLocationId || "";
    }

    if (utils.financeOption === "monthly") {
        if (basket.financePacks.length > 0) {
            packs.push(...basket.financePacks.map((pack) => ({ id: pack.id, shortId: pack.shortId })));
        }
        if (basket.financePackServiceProducts.length > 0) {
            serviceProducts.push(
                ...basket.financePackServiceProducts.map((serviceProduct) => ({
                    id: serviceProduct.id,
                    shortId: serviceProduct.shortId,
                })),
            );
        }
        if (basket.financePackExtras.length > 0) {
            options.push(
                ...basket.financePackExtras
                    .filter((extra) => extra.type === "option")
                    .map((option) => ({ id: option.id, shortId: option.shortId })),
            );
            accessories.push(
                ...basket.financePackExtras
                    .filter((extra) => extra.type === "accessory")
                    .map((accesory) => ({ id: accesory.id, shortId: accesory.shortId })),
            );
        }
    }

    return {
        modelId: car.model.id,
        car: { id: car.id, shortId: car.shortId.toString() },
        wheel: { id: basket.wheel.id, shortId: basket.wheel.shortId },
        colour: { id: basket.colour.id, code: basket.colour.internalCode },
        upholstery: { id: basket.upholstery.id, code: basket.upholstery.internalCode },
        packs,
        serviceProducts,
        options,
        accessories,
        returnSpecificationsMapping,
        taxLocationId,
        priceCalculationServiceType:
            overridePriceCalculationService ||
            getPriceCalculationServiceEndpointType(bnbSettings.priceCalculationService),
    };
};
